
import g from "../globals/variables";

const Header = {

  lastScrollTop: 0,

  init: () => {
    window.addEventListener("scroll", Header.hideHeader);
  },

  hideHeader: () => {
    const currentScrollTop = -document.body.getBoundingClientRect().top;
    const scrollingDown = currentScrollTop > Header.lastScrollTop;
    Header.lastScrollTop = currentScrollTop;

    if (currentScrollTop > g.el.header.offsetHeight && scrollingDown && window.innerWidth < g.resolution.m) {
      g.el.header.classList.add("header--hidden");
    } else {
      g.el.header.classList.remove("header--hidden");
    }
  },
};

export default Header;
